import { render, staticRenderFns } from "./AccommodationPhoneCard.vue?vue&type=template&id=f830a55a&scoped=true&"
import script from "./AccommodationPhoneCard.vue?vue&type=script&lang=js&"
export * from "./AccommodationPhoneCard.vue?vue&type=script&lang=js&"
import style0 from "./AccommodationPhoneCard.vue?vue&type=style&index=0&id=f830a55a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f830a55a",
  null
  
)

export default component.exports